import { render, staticRenderFns } from "./AssociateCustomer.vue?vue&type=template&id=f0e842da&"
import script from "./AssociateCustomer.vue?vue&type=script&lang=js&"
export * from "./AssociateCustomer.vue?vue&type=script&lang=js&"
import style0 from "./AssociateCustomer.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports